export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  image: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    slug: "beginner-guide",
    name: "新手入门",
    description: "黄油游戏新手快速上手，从零开始掌握黄油游戏基础操作与核心玩法",
    icon: "ri-rocket-line",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20gaming%20setup%20scene%20with%20a%20controller%20and%20guidebook%20on%20a%20wooden%20desk%2C%20soft%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20beginner-friendly%20vibe%2C%20warm%20amber%20tones%2C%20clean%20composition%2C%20minimalist%20game%20room%20aesthetic%2C%20editorial%20photography%20style%20with%20gentle%20bokeh%20background&width=800&height=600&seq=cat-beginner-01&orientation=landscape",
    articleCount: 5
  },
  {
    id: "cat-2",
    slug: "hot-recommendations",
    name: "热门推荐",
    description: "精选黄油游戏热门作品，发现当下最受玩家欢迎的黄油游戏佳作",
    icon: "ri-fire-line",
    image: "https://readdy.ai/api/search-image?query=A%20vibrant%20and%20exciting%20gaming%20collection%20display%20with%20colorful%20game%20covers%20arranged%20artistically%2C%20warm%20energetic%20lighting%2C%20dynamic%20composition%2C%20trending%20popular%20games%20aesthetic%2C%20modern%20display%20shelf%20with%20warm%20golden%20accents%2C%20editorial%20style%2C%20rich%20textures&width=800&height=600&seq=cat-hot-01&orientation=landscape",
    articleCount: 6
  },
  {
    id: "cat-3",
    slug: "advanced-guide",
    name: "进阶攻略",
    description: "黄油游戏深度玩家必读，解锁黄油游戏高难度关卡与隐藏内容",
    icon: "ri-treasure-map-line",
    image: "https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20gaming%20scene%20with%20ancient%20map%20and%20treasure%20elements%20on%20a%20dark%20wooden%20table%2C%20warm%20dramatic%20lighting%20from%20a%20lantern%2C%20adventure%20treasure%20hunt%20theme%2C%20intricate%20details%2C%20rich%20dark%20amber%20tones%2C%20editorial%20photography%20with%20deep%20shadows%20and%20highlights&width=800&height=600&seq=cat-advanced-01&orientation=landscape",
    articleCount: 5
  },
  {
    id: "cat-4",
    slug: "gameplay-tutorial",
    name: "玩法教程",
    description: "黄油游戏各类玩法详细解析，从战斗系统到角色养成一网打尽",
    icon: "ri-gamepad-line",
    image: "https://readdy.ai/api/search-image?query=A%20detailed%20gaming%20tutorial%20scene%20with%20a%20game%20controller%20next%20to%20a%20notebook%20with%20handwritten%20notes%2C%20warm%20desk%20lamp%20lighting%2C%20organized%20workspace%2C%20learning%20and%20gaming%20atmosphere%2C%20cozy%20amber%20and%20brown%20tones%2C%20clean%20minimalist%20composition%2C%20editorial%20photography%20style&width=800&height=600&seq=cat-tutorial-01&orientation=landscape",
    articleCount: 4
  },
  {
    id: "cat-5",
    slug: "download-resources",
    name: "下载资源",
    description: "黄油游戏资源一站式获取，官方下载渠道与必备工具合集",
    icon: "ri-download-cloud-line",
    image: "https://readdy.ai/api/search-image?query=A%20modern%20digital%20download%20concept%20scene%20with%20a%20laptop%20displaying%20game%20library%20interface%2C%20warm%20screen%20glow%2C%20clean%20workspace%20with%20warm%20ambient%20lighting%2C%20organized%20digital%20downloads%20aesthetic%2C%20amber%20and%20cream%20color%20scheme%2C%20editorial%20style%20with%20soft%20shadows&width=800&height=600&seq=cat-download-01&orientation=landscape",
    articleCount: 3
  }
];